module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"onlineService":"The first automated interview","withHumanFace":"service with a real person","candidatesSupport":"Candidate support","confidential":"Privacy policy","userAgreement":"Terms of use","serviceRules":"Conditions of service","paymentInfo":"Payment rules","copyright":"All rights reserved"}}')
  delete Component.options._Ctor
}
